module.exports = __webpack_public_path__ + "static/media/MichaelMcDonaldCV2021.350a1ca0.pdf";